export default __webpack_public_path__ + "static/media/event.ffd4b05d.png";